export default {
	SetFxRates(state, data) {
		state.fxRates = data
	},
}
